export default __webpack_public_path__ + "static/media/04.f9f48fd1.webp";